import { render, staticRenderFns } from "./ImgSlider.vue?vue&type=template&id=2b2aa617&scoped=true&"
import script from "./ImgSlider.vue?vue&type=script&lang=js&"
export * from "./ImgSlider.vue?vue&type=script&lang=js&"
import style0 from "./ImgSlider.vue?vue&type=style&index=0&id=2b2aa617&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2aa617",
  null
  
)

export default component.exports